import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';
import Datepicker from '../Datepicker';

const IS_INVALID_CLASS = 'is-invalid';
const IS_FOCUSED_CLASS = 'is-focused';

class DuetDateComponent extends FormComponent {
	init(questionData) {
		this.renderInputField(questionData);
	}

	markup(value, data = {}, titleMarkup) {
		this.inputFieldContainerClass = `lta-input-field-container-${data.id}`;
		this.inputID = `lta-input-field-id-${data.id}`;
		const placeholderText = data?.placeHolder || 'DD-MM-YYYY';
		const inputValue = data?.value || '';
		return `<div class="lta-datepicker-title">${titleMarkup}</div>
			<lta-date-picker
				class="js-datepicker u-mb-3 ${this.inputFieldContainerClass}"
				input-id="${this.inputID}"
				name="${data?.id || ''}"
				placeholder="${placeholderText}"
				value="${inputValue}"
				min="${data?.minDate || ''}"
				max="${data?.maxDate || ''}"
				display-format="DD-MM-YYYY"
				show-icons="true"
			>
				${this.renderInstructionLabel(data.instructionText)}
				${this.renderLabel(this.inputID)}
				<div class="lta-text-input--error"></div>
			</lta-date-picker>`;
	}

	renderLabel(inputID) {
		return this.data.titlePattern
			? ``
			: `<label for="${inputID}" class="lta-text-input__label u-text-grey-lta">${this.data.label}</label>`;
	}

	renderInstructionLabel(instructionLabel) {
		return instructionLabel
			? `<div class="u-mb-2"><span class="lta-text-input__label-instruction">${instructionLabel}</span></div>`
			: '';
	}

	afterRender() {
		this.componentElement = SelectorEngine.findOne('lta-date-picker', this._element);
		this.inputFieldContainerElement = this.componentElement;
		this.datePickerComponent =
			Datepicker.getInstance(this.componentElement) || new Datepicker(this.componentElement, {});
		this.datePickerComponent.format = 'DD-MM-YYYY';
		this.datePickerComponent.onChange((value) => {
			this.duetDateValue = value;
			this.handleInput(value);
		});

		if (this.data?.value) {
			setTimeout(() => {
				this.duetDateValue = this.data?.value;
				this.handleInput(this.data?.value);
			}, 100);
		}
	}

	handleInput(value) {
		if (this.data?.id === 'tournament-start-date') {
			this.startDateValue = value;
		} else if (this.data?.id === 'tournament-end-date') {
			this.endDateValue = value;
		}
		if (this.validate()) {
			this.value = {
				...this.data,
				value: value
			};
			if (this.value) {
				this.dependentQuestion = this.value.dependentQuestion;
			}
		}
	}

	validate() {
		let isValidValue = true;
		if (!this.duetDateValue) {
			isValidValue = false;
			this.addInvalidClass(this.data?.errorMessage);
		} else {
			const dateArray = this.duetDateValue.split('-');
			this.dateObject = { day: dateArray[2], month: dateArray[1], year: dateArray[0] };
		}
		return isValidValue;
	}

	dateValidate(year, month, day) {
		const parseMonth = Number.parseInt(month - 1, 10);
		const d = new Date(year, parseMonth, day);
		if (d.getFullYear() == year && d.getMonth() == parseMonth && d.getDate() == day) {
			return true;
		}
		return false;
	}

	removeInvalidClass() {
		const errorElement = SelectorEngine.findOne('.lta-text-input--error', this.inputFieldContainerElement);
		if (errorElement) {
			errorElement.innerHTML = '';
		}
		this.inputFieldContainerElement?.classList.remove(IS_INVALID_CLASS);
		this.inputFieldContainerElement?.classList.remove(IS_FOCUSED_CLASS);
		this.datePickerComponent?.fp?.altInput?.setAttribute('aria-invalid', 'false');
		this.componentElement?.setAttribute('has-error', 'false');
	}

	addInvalidClass(errorMessage) {
		const errorElement = SelectorEngine.findOne('.lta-text-input--error', this.inputFieldContainerElement);
		if (errorElement) {
			errorElement.innerHTML = errorMessage;
		}
		this.inputFieldContainerElement?.classList.add(IS_INVALID_CLASS);
		this.inputFieldContainerElement?.classList.add(IS_FOCUSED_CLASS);
		this.datePickerComponent?.fp?.altInput?.setAttribute('aria-invalid', 'true');
		this.componentElement?.setAttribute('has-error', 'true');
	}
}

export default DuetDateComponent;
